(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {

  const cart = document.querySelector('.avexis-cart');

  if (!cart) {
    return;
  }


  const form = cart.querySelector('.avexis-cart__form');

  if (!form) {
    return;
  }


  /* =======================================================
     UPDATE CART AUTOMATICALLY
     ======================================================= */

  const updateCart = () => {

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }

  };


  /* =======================================================
     QUANTITY CONTROLS
     ======================================================= */

  const quantityControls = cart.querySelectorAll(
    '.avexis-cart-item__quantity-control'
  );


  quantityControls.forEach((control) => {

    const input = control.querySelector(
      '[data-cart-quantity]'
    );

    const minus = control.querySelector(
      '[data-cart-minus]'
    );

    const plus = control.querySelector(
      '[data-cart-plus]'
    );


    if (!input) {
      return;
    }


    if (minus) {

      minus.addEventListener('click', () => {

        const currentValue =
          parseInt(input.value, 10) || 0;

        input.value = Math.max(
          0,
          currentValue - 1
        );

        updateCart();

      });

    }


    if (plus) {

      plus.addEventListener('click', () => {

        const currentValue =
          parseInt(input.value, 10) || 0;

        input.value =
          currentValue + 1;

        updateCart();

      });

    }


    /* =====================================================
       MANUAL INPUT
       ===================================================== */

    input.addEventListener('change', () => {

      let value =
        parseInt(input.value, 10);

      if (Number.isNaN(value) || value < 0) {
        value = 1;
      }

      input.value = value;

      updateCart();

    });

  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {

  const filterForm = document.querySelector('.avexis-catalog');
  const filterPanel = document.querySelector('[data-filter-panel]');
  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filterCloseButtons = document.querySelectorAll('[data-filter-close]');
  const sortSelect = document.querySelector('[data-sort-select]');

  if (!filterForm) {
    return;
  }


  /* =======================================================
     FILTER SUBMIT
     ======================================================= */

  const filterInputs = filterForm.querySelectorAll(
    'input[type="checkbox"]'
  );

  filterInputs.forEach((input) => {

    input.addEventListener('change', () => {
      filterForm.submit();
    });

  });


  /* =======================================================
     SORT
     ======================================================= */

  if (sortSelect) {

    sortSelect.addEventListener('change', () => {
      filterForm.submit();
    });

  }


  /* =======================================================
     MOBILE FILTER PANEL
     ======================================================= */

  if (filterToggle && filterPanel) {

    filterToggle.addEventListener('click', () => {

      filterPanel.classList.add('is-open');

      document.body.classList.add(
        'avexis-filters-open'
      );

    });

  }


  filterCloseButtons.forEach((button) => {

    button.addEventListener('click', () => {

      if (filterPanel) {
        filterPanel.classList.remove('is-open');
      }

      document.body.classList.remove(
        'avexis-filters-open'
      );

    });

  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {

  /* =======================================================
     QUANTITY
     ======================================================= */

  const productSection = document.querySelector('.avexis-product');

  if (!productSection) {
    return;
  }

  const quantityInput = productSection.querySelector(
    'input[name="quantity"]'
  );

  const minusButton = productSection.querySelector(
    '[data-quantity-minus]'
  );

  const plusButton = productSection.querySelector(
    '[data-quantity-plus]'
  );


  if (quantityInput && minusButton && plusButton) {

    minusButton.addEventListener('click', () => {

      const currentValue =
        parseInt(quantityInput.value, 10) || 1;

      quantityInput.value = Math.max(
        1,
        currentValue - 1
      );

      quantityInput.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );

    });


    plusButton.addEventListener('click', () => {

      const currentValue =
        parseInt(quantityInput.value, 10) || 1;

      quantityInput.value =
        currentValue + 1;

      quantityInput.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );

    });

  }


  /* =======================================================
     IMAGE THUMBNAILS
     ======================================================= */

  const mainImage = productSection.querySelector(
    '.avexis-product__main-image-element'
  );

  const thumbnails = productSection.querySelectorAll(
    '[data-product-thumbnail]'
  );


  thumbnails.forEach((thumbnail) => {

    thumbnail.addEventListener('click', () => {

      const image = thumbnail.querySelector('img');

      if (!mainImage || !image) {
        return;
      }

      mainImage.src = image.src;

      mainImage.removeAttribute('srcset');

      thumbnails.forEach((item) => {
        item.classList.remove('is-active');
      });

      thumbnail.classList.add('is-active');

    });

  });

});


  } catch(e) { console.error(e); }
})();
})();
